import { AdditionalInfoStep } from '../components'
import { useDemographicsPage } from './demographics/useDemographicsPage'

export function DemographicsPage() {
  const {
    error,
    formData,
    handleContinue,
    handleContinueWithoutEndorsements,
    isSubmitting,
    navigate,
    updateFormData
  } = useDemographicsPage()

  return (
    <div className="bg-white px-4 py-2">
      <div className="mx-auto max-w-4xl">
        <AdditionalInfoStep
          currentStep={1}
          totalSteps={2}
          fieldEditability={{}}
          formData={formData}
          updateFormData={updateFormData}
          onBack={() => navigate('/schedule')}
          onContinue={() => {
            void handleContinue()
          }}
          onContinueWithoutEndorsements={() => {
            void handleContinueWithoutEndorsements()
          }}
          isSubmitting={isSubmitting}
          errorMessage={error}
        />
      </div>
    </div>
  )
}
